import styled, { css } from 'styled-components'
import Autocomplete from '@mui/material/Autocomplete'

export const AutoComplete = styled(Autocomplete)(
  ({ theme }) => css`
    && {
      .MuiInputLabel-root {
        font-size: ${theme.typograph.fontsize.h3};
      }
      .MuiOutlinedInput-root .MuiAutocomplete-input {
        font-family: ${theme.typograph.fontFamily.primary};
        font-style: normal;
        font-weight: 400;
        font-size: ${theme.typograph.fontsize.h3};
        line-height: ${theme.typograph.fontsize.h8};
      }
      .MuiOutlinedInput-input {
        padding: ${theme.layout.padding.small};
        font-size: ${theme.typograph.fontsize.h3};
      }
    }
  `
)
